import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';

import ApplicationController from '../application-controller';

export default class extends ApplicationController {
  declare swiper?: Swiper;

  static targets = ['root', 'navigationPrevButton', 'navigationNextButton'];

  declare readonly hasRootTarget: boolean;
  declare readonly rootTarget: HTMLElement;
  declare readonly rootTargets: HTMLElement[];

  declare readonly hasNavigationPrevButtonTarget: boolean;
  declare readonly navigationPrevButtonTarget: HTMLElement;
  declare readonly navigationPrevButtonTargets: HTMLElement[];

  declare readonly hasNavigationNextButtonTarget: boolean;
  declare readonly navigationNextButtonTarget: HTMLElement;
  declare readonly navigationNextButtonTargets: HTMLElement[];

  static values = {
    options: { type: Object, default: {} },
  };

  declare readonly optionsValue: SwiperOptions;

  connect() {
    super.connect();
    this.initSwiper();
  }

  initSwiper() {
    console.log('OPTIONS', this.swiperOptions);

    this.swiper = new Swiper(this.rootElement, this.swiperOptions);
  }

  get rootElement() {
    if (this.hasRootTarget) {
      return this.rootTarget;
    }

    return this.element as HTMLElement;
  }

  get navigationPrevButton(): HTMLElement | string {
    if (this.hasNavigationPrevButtonTarget) {
      return this.navigationPrevButtonTarget;
    }

    return '.swiper-button.swiper-button-prev';
  }

  get navigationNextButton(): HTMLElement | string {
    if (this.hasNavigationNextButtonTarget) {
      return this.navigationNextButtonTarget;
    }

    return '.swiper-button.swiper-button-next';
  }

  get swiperOptions(): SwiperOptions {
    return {
      modules: [Navigation, Pagination],
      direction: 'horizontal',
      slidesPerView: 2,
      spaceBetween: 10,
      loop: false,

      navigation: {
        prevEl: this.navigationPrevButton,
        nextEl: this.navigationNextButton,
      },

      a11y: {
        prevSlideMessage: 'Slide précédente',
        nextSlideMessage: 'Slide suivante',
      },

      ...this.optionsValue,
    };
  }
}
